import React, { PureComponent, PropTypes } from 'react';

import './HourLabel.css';

export default class HourLabel extends PureComponent {
    static propTypes = {
        hour: PropTypes.string.isRequired,
    }

    render() {
        return (
            <div className="hour-label">
                {this.props.hour}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/TimeSelector/HourLabel.jsx